import { ButtonProps } from "@/components/atoms/Link/link"
import Link, { LinkProps } from "next/link"
import * as React from "react"
import { cn } from '@/utils/index'

// Molecule Component: PaginationLink
type PaginationLinkProps = {
  isActive?: boolean
  className?: string
  children?: React.ReactNode
  disabled?: boolean
  "aria-label"?: string
} & Pick<ButtonProps, "size"> &
  LinkProps

export const PaginationLink = React.forwardRef<HTMLAnchorElement, PaginationLinkProps>(
  ({ className, isActive, children, href, disabled, "aria-label": ariaLabel }, ref) => (
    <Link
      ref={ref}
      prefetch={false}
      scroll={false}
      aria-current={isActive ? "page" : undefined}
      aria-label={ariaLabel}
      className={cn(
        "size-9 items-center justify-center bg-white px-0 py-0 text-[16px] text-slate-800 transition-colors rounded-full hover:bg-black hover:text-white dark:bg-black dark:text-slate-300 dark:hover:bg-white dark:hover:text-black md:flex",
        { "rounded-full bg-black font-bold text-white": isActive },
        { "pointer-events-none cursor-not-allowed opacity-50": disabled },
        className
      )}
      href={href}
    >
      {children}
    </Link>
  )
)
PaginationLink.displayName = "PaginationLink"
